import React from 'react';
import { painPoints } from '../../data/content';
import { SectionCta } from '../SectionCta';
export function PainPoints() {
  return <section className="bg-white px-4 py-14 sm:px-6 sm:py-20" data-id="element-217" data-mp="1twgxmxbs8kca">
      <div className="mx-auto max-w-5xl" data-id="element-218" data-mp="27mu04k5wn6u8">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.16em] text-teal-600" data-id="element-219" data-mp="27nlnj7pcly9f">
          👉 Does this sound familiar?
        </p>
        <h2 className="mt-3 text-center font-display text-[26px] font-bold leading-tight text-navy-800 sm:text-4xl" data-id="element-220" data-mp="2hjp0z9pnhjbo">
          If you answer <em className="italic text-teal-600" data-id="element-221" data-mp="2ckvljbqszi8v">yes</em> to any of these… this system
          was created for you
        </h2>

        <ul className="mt-9 grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-222" data-mp="2qitz4exavanb">
          {painPoints.map(item => <li key={item.text} className="flex flex-col rounded-2xl border border-navy-100 bg-cream p-5" data-id="element-223" data-mp="w75hu63livzr">
              <span aria-hidden="true" className="text-2xl" data-id="element-224" data-mp="s6v9wnw8tvi9">
                {item.icon}
              </span>
              <p className="mt-3 text-[14px] leading-relaxed text-navy-700/85 sm:text-[15px]" data-id="element-225" data-mp="1n9eiq4uc5edp">
                {item.text}
              </p>
            </li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-2xl rounded-3xl bg-navy-800 p-6 text-center sm:p-8" data-id="element-226" data-mp="1x4y7m7ahfcsy">
          <p className="font-display text-xl font-bold leading-snug text-white sm:text-2xl" data-id="element-227" data-mp="21xrcqw9v4n5k">
            And it shouldn't have to be this way.
          </p>
          <p className="mt-3 text-[15px] leading-relaxed text-white/75 sm:text-base" data-id="element-228" data-mp="2axe40p8vockw">
            Because the problem isn't necessarily your knowledge. The problem is not having a visual
            system that organizes the information you need to review and verify.
          </p>
        </div>

        <SectionCta label="I want a visual system for my consultations" data-id="element-229" data-mp="lig374uw4vja" />
      </div>
    </section>;
}